module.exports = __webpack_public_path__ + "static/media/dashboard_light.c11a2b7a.svg";